<div>
  <div class="filter-title">Filters</div>
  <div class="filter-group">
    <ng-container *ngFor="let filter of filters" [ngSwitch]="filter.type">
      <div class="filter-container">
        <div>
          <!-- input -->
          <ng-template ngSwitchCase="input">
            <label *ngIf="!filter.queryExclude">{{ filter.label }}</label>
            <div *ngIf="filter.queryExclude" class="label-row">
              <label>{{ filter.label }}</label>
              <mat-checkbox
                color="warn"
                [(ngModel)]="filterValues[filter.queryExclude]"
                (ngModelChange)="debounceEmitChange()"
              >
                Exclude
              </mat-checkbox>
            </div>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="filterValues[filter.id]"
              (ngModelChange)="debounceEmitChange()"
            />
          </ng-template>

          <!-- date -->
          <ng-template ngSwitchCase="date">
            <label>{{ filter.label }}</label>
            <input
              type="date"
              class="form-control"
              [(ngModel)]="filterValues[filter.id]"
              (ngModelChange)="emitChange()"
            />
          </ng-template>

          <!-- select -->
          <ng-template ngSwitchCase="select">
            <label *ngIf="!filter.queryExclude">{{ filter.label }}</label>
            <div *ngIf="filter.queryExclude" class="label-row">
              <label>{{ filter.label }}</label>
              <mat-checkbox
                color="warn"
                [(ngModel)]="filterValues[filter.queryExclude]"
                (ngModelChange)="debounceEmitChange()"
              >
                Exclude
              </mat-checkbox>
            </div>
            <select
              class="form-control"
              [(ngModel)]="filterValues[filter.id]"
              (ngModelChange)="emitChange()"
            >
              <option [value]="option.value" *ngFor="let option of filter.options">
                {{ option.label }}
              </option>
            </select>
          </ng-template>

          <!-- toggle -->
          <ng-template ngSwitchCase="toggle">
            <filter-toggle
              [label]="filter.label"
              [value]="filterValues?.[filter.id]"
              (changeToggle)="updateAndEmitChange(filter.id, $event)"
              [options]="filter.options"
            ></filter-toggle>
          </ng-template>

          <!-- productDept -->
          <ng-template ngSwitchCase="productDept">
            <filter-product-dept
              [label]="filter.label"
              [value]="filterValues?.[filter.id] || ''"
              (selectChange)="updateAndEmitChange(filter.id, $event)"
            ></filter-product-dept>
          </ng-template>

          <!-- Internal Sales Channel -->
          <ng-template ngSwitchCase="posChannel">
            <div class="label-row">
              <label>{{ filter.label }}</label>
            </div>
            <lum-channel-control
              [formControl]="posChannelControl"
              [isPosChannel]="true"
            ></lum-channel-control>
          </ng-template>

          <!-- warehouseLocation -->
          <ng-template ngSwitchCase="warehouseLocation">
            <filter-warehouse-location
              [value]="filterValues?.[filter.id]"
              [query]="filter.query"
              (warehouseLocationChange)="updateAndEmitChange(filter.id, $event)"
            ></filter-warehouse-location>
          </ng-template>

          <!-- channels -->
          <ng-template ngSwitchCase="channels">
            <filter-channels
              [value]="filterValues?.[filter.id]"
              (changeChannels)="updateAndEmitChange(filter.id, $event)"
              [label]="filter.label"
              [options]="filter.options"
              [usedFrom]="filter.usedFrom"
            ></filter-channels>
          </ng-template>

          <!-- clients -->
          <ng-template ngSwitchCase="clients">
            <filter-clients
              [value]="filterValues?.[filter.id]"
              (changeClients)="updateAndEmitChange(filter.id, $event)"
              [label]="filter.label"
              [options]="filter.options"
            ></filter-clients>
          </ng-template>

          <!-- client type -->
          <ng-template ngSwitchCase="clientType">
            <filter-client-types
              [value]="filterValues?.[filter.id]"
              (changeClientTypes)="updateAndEmitChange(filter.id, $event)"
              [label]="filter.label"
              [options]="filter.options"
            ></filter-client-types>
          </ng-template>

          <!-- tags -->
          <ng-template ngSwitchCase="tags">
            <filter-tags
              [value]="filterValues?.[filter.id]"
              (changeTags)="updateAndEmitChange(filter.id, $event)"
              [label]="filter.label"
            ></filter-tags>
          </ng-template>

          <!-- sourcing assignee -->
          <ng-template ngSwitchCase="sourcingAssignee">
            <filter-sourcing-assignee
              [value]="filterValues?.[filter.id]"
              (changeSourcingAssignee)="updateAndEmitChange(filter.id, $event)"
              [label]="filter.label"
            ></filter-sourcing-assignee>
          </ng-template>

          <!-- category -->
          <ng-template ngSwitchCase="category">
            <filter-category
              [value]="filterValues?.[filter.id]"
              (changeCategory)="updateAndEmitChange(filter.id, $event)"
              [label]="filter.label"
            ></filter-category>
          </ng-template>

          <!-- subCategory -->
          <ng-template ngSwitchCase="subCategory">
            <filter-sub-category
              [value]="filterValues?.[filter.id]"
              [categoryIds]="filterValues?.['category']"
              (changeSubCategory)="updateAndEmitChange(filter.id, $event)"
              [label]="filter.label"
            ></filter-sub-category>
          </ng-template>

          <!-- clientPurchaseOrderTypes -->
          <ng-template ngSwitchCase="clientPurchaseOrderTypes">
            <filter-client-purchase-order-type
              [value]="filterValues?.[filter.id]"
              (changeType)="updateAndEmitChange(filter.id, $event)"
              [label]="filter.label"
            ></filter-client-purchase-order-type>
          </ng-template>

          <!-- clientPurchaseOrderTypes -->
          <ng-template ngSwitchCase="staff">
            <filter-staff
              [value]="filterValues?.[filter.id]"
              (changeStaff)="updateAndEmitChange(filter.id, $event)"
              [label]="filter.label"
              [options]="filter.options"
            ></filter-staff>
          </ng-template>

          <!-- clientPurchaseOrderTypes -->
          <ng-template ngSwitchCase="factory">
            <filter-factory
              [value]="filterValues?.[filter.id]"
              (changeFactory)="updateAndEmitChange(filter.id, $event)"
              [label]="filter.label"
              [options]="filter.options"
            ></filter-factory>
          </ng-template>

          <!-- clientPaymentTerms -->
          <ng-template ngSwitchCase="clientPaymentTerms">
            <filter-client-payment-term
              [value]="filterValues?.[filter.id]"
              (changePaymentTerm)="updateAndEmitChange(filter.id, $event)"
              [label]="filter.label"
            ></filter-client-payment-term>
          </ng-template>

          <!-- salesRepAssignee -->
          <ng-template ngSwitchCase="salesRepAssignee">
            <filter-sales-rep-assignee
              [value]="filterValues?.[filter.id]"
              (changeSalesRepAssignee)="updateAndEmitChange(filter.id, $event)"
              [label]="filter.label"
            ></filter-sales-rep-assignee>
          </ng-template>

          <!-- company -->
          <ng-template ngSwitchCase="company">
            <filter-company
              [value]="filterValues?.[filter.id]"
              (changeCompany)="updateAndEmitChange(filter.id, $event)"
              [label]="filter.label"
            ></filter-company>
          </ng-template>

          <!-- warehouseGroup -->
          <ng-template ngSwitchCase="warehouseGroup">
            <filter-warehouse-group
              [value]="filterValues?.[filter.id]"
              [query]="filter.query"
              (warehouseGroupChange)="updateAndEmitChange(filter.id, $event)"
            ></filter-warehouse-group>
          </ng-template>

          <!-- fulfillmentStatus -->
          <ng-template ngSwitchCase="fulfillmentStatus">
            <filter-fulfillment-status
              [value]="filterValues?.[filter.id]"
              (changeStatus)="updateAndEmitChange(filter.id, $event)"
              [label]="filter.label"
              [options]="filter.options"
            ></filter-fulfillment-status>
          </ng-template>

          <!-- multiselect -->
          <ng-template ngSwitchCase="multiselect">
            <filter-multiselect
              [value]="filterValues?.[filter.id]"
              (changeSelection)="updateAndEmitChange(filter.id, $event)"
              [label]="filter.label"
              [options]="filter.options"
            ></filter-multiselect>
          </ng-template>

          <!-- Invoice Payment Status -->
          <ng-template ngSwitchCase="invoicePaymentStatus">
            <filter-payment-status
              [value]="filterValues?.[filter.id]"
              (changeStatus)="updateAndEmitChange(filter.id, $event)"
              [label]="filter.label"
              [options]="filter.options"
            ></filter-payment-status>
          </ng-template>

          <!-- Purchase Order ID / Status -->
          <ng-template ngSwitchCase="multiInput">
            <filter-multi-input
              [value]="filterValues?.[filter.id]"
              (changeSelection)="updateAndEmitChange(filter.id, $event)"
              [label]="filter.label"
              [placeholder]="filter.placeholder ?? ''"
              [inputMode]="filter.inputMode"
            ></filter-multi-input>
          </ng-template>

          <!-- Custom Field -->
          <ng-template ngSwitchCase="customField">
            <filter-custom-field
              [customField]="filter.customField"
              [value]="filterValues?.[filter.id]"
              (changeValue)="updateAndEmitChange(filter.id, $event)"
            ></filter-custom-field>
          </ng-template>
        </div>
        <div class="filter-close-button">
          <button
            class="filter-small-button"
            (click)="removeFilter(filter)"
            matTooltip="Remove filter"
          >
            <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </ng-container>

    <div class="filter-actions">
      <button mat-flat-button color="primary" [matMenuTriggerFor]="menu">
        + Add Filter
        <i class="fa fa-caret-down menu-caret"></i>
      </button>
      <mat-menu #menu="matMenu" class="filter-menu">
        <button
          mat-menu-item
          *ngFor="let filter of configuration"
          class="filter-menu-item"
          (click)="addFilter(filter)"
        >
          {{ filter.label }}
          <i
            *ngIf="isSelected(filter.id)"
            class="filter-check fa fa-check-circle"
          ></i>
        </button>
      </mat-menu>
    </div>
    <div class="filter-reset">
      <button
        matTooltip="Reset filters"
        class="filter-small-button"
        (click)="reset()"
      >
        <i class="fa fa-undo"></i>
      </button>
    </div>
  </div>
</div>
